import { Box, HStack, IconButton, Shadow, Stack, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';

import { MultipleAccountsSelection } from '../../../../components/MultipleAccountsSelection';

import { CustomerAccountStatus } from './shared/CustomerAccountStatus';
import { CustomerName } from './shared/CustomerName';
import { IncomeTaxButton } from './shared/IncomeTaxButton';

import { CustomerTableItemTypes } from '.';

export const CustomerTableItemMobile: React.FC<CustomerTableItemTypes.Props> = ({
  customer,
  isExporting,
  onDownloadIncomeStatementFile,
  customerDetailNavigation,
  customerDetailHref,
  setAccountSelected,
  accountSelected,
}) => {
  const hasMultipleAccounts = customer.accountsNormalized.length > 1;

  return (
    <Shadow level={1} borderRadius={BoxBorder.heavy}>
      <VStack space="stack.xxxs" p="inset.xs">
        <CustomerName customer={customer} />

        <VStack space="stack.nano">
          <HStack space="stack.quarck" justifyContent="space-between">
            <Text variant="semibold">CPF/CNPJ</Text>
            <Text>{customer.cpfCnpjNormalized}</Text>
          </HStack>

          <Box w="full" h="1px" bg="neutral.lightest" />

          <HStack space="stack.quarck" justifyContent="space-between">
            <Text variant="semibold">Cadastro</Text>
            <CustomerAccountStatus customer={customer} />
          </HStack>

          <Box w="full" h="1px" bg="neutral.lightest" />

          <Stack
            space="stack.quarck"
            justifyContent={hasMultipleAccounts ? 'flex-start' : 'space-between'}
            direction={hasMultipleAccounts ? 'column' : 'row'}>
            <Text variant="semibold">Conta de custódia</Text>
            <MultipleAccountsSelection
              isMobile
              accounts={customer.accountsNormalized}
              accountSelected={accountSelected}
              setAccountSelected={setAccountSelected}
            />
          </Stack>
        </VStack>

        <HStack alignItems="center" space="stack.nano" justifyContent="space-between">
          <IncomeTaxButton
            isExporting={isExporting}
            customer={customer}
            onDownloadIncomeStatementFile={onDownloadIncomeStatementFile}
          />
          <IconButton
            onPress={customerDetailNavigation}
            testId="customers-table-item-mobile-action"
            icon="ArrowRight"
            iconSize="xxs"
            iconColor="brand.tertiary.principal"
            href={customerDetailHref}
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
